export default __webpack_public_path__ + "static/media/area.15f069fd.svg";